import React from 'react'
import BlogList from '../../Component/Blog/BlogList'
import Seo from '../../Component/Seo'

function Blogs() {
  return (
    <div className="body-bg pt-[140px] pb-20">
      <Seo
        title='Halal Finance Blog and Guides | Halal Wealth'
        description='Read practical guides on halal saving, ethical investing, and Islamic personal finance. Learn how to grow wealth without compromising your values.'
        pathname='/blog'
      />
      <BlogList />
    </div>
  )
}

export default Blogs
